<div class="dialog-header">
    <h2 mat-dialog-title>Add Employee Leave</h2>
    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <mat-stepper [orientation]="stepperOrientation" #stepper linear>
        <!-- Step 1: Select Employee -->
        <mat-step [stepControl]="EmployeeGroup" [editable]="true">
            <ng-template matStepLabel>Select Employee</ng-template>
            <form [formGroup]="EmployeeGroup" class="step-form">
                <div class="step-content">
                    <p class="step-description">Please select an employee</p>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Employee</mat-label>
                        <mat-select formControlName="employeeID" (selectionChange)="onEmployeeChange($event.value)"
                            (openedChange)="onEmployeeDropdownOpenChange($event)" required>
                            <mat-select-trigger>
                                {{ getSelectedEmployeeName() || 'Select Employee' }}
                            </mat-select-trigger>
                            <mat-option class="search-option">
                                <input #employeeSearchInput [(ngModel)]="employeeSearchText"
                                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEmployees()"
                                    (click)="$event.stopPropagation()" placeholder="Search employees..."
                                    class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let employee of filteredEmployees" [value]="employee.C_BPartner_ID">
                                {{employee.employeeName}}
                            </mat-option>
                            <mat-option *ngIf="filteredEmployees.length === 0 && employeeSearchText" disabled>
                                <em>No employees found</em>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="EmployeeGroup.get('employeeID')?.hasError('required')">
                            Employee is required
                        </mat-error>
                    </mat-form-field>
                    <div class="button-row">
                        <button mat-raised-button color="primary" matStepperNext
                            [disabled]="!EmployeeGroup.valid">Next</button>
                    </div>
                </div>
            </form>
        </mat-step>

        <!-- Step 2: Select Period -->
        <mat-step [stepControl]="PeriodGroup" [editable]="true">
            <ng-template matStepLabel>Select Period</ng-template>
            <form [formGroup]="PeriodGroup" class="step-form">
                <div class="step-content">
                    <p class="step-description">Please select a payroll period</p>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Period</mat-label>
                        <mat-select formControlName="payrollPeriodID" (selectionChange)="onPeriodChange($event.value)"
                            (openedChange)="onPeriodDropdownOpenChange($event)" required>
                            <mat-select-trigger>
                                {{ getSelectedPeriodName() || 'Select Period' }}
                            </mat-select-trigger>
                            <mat-option class="search-option">
                                <input #periodSearchInput [(ngModel)]="periodSearchText"
                                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterPeriods()"
                                    (click)="$event.stopPropagation()" placeholder="Search periods..."
                                    class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let payroll of filteredPayrollPeriods" [value]="payroll.hrperiodID">
                                {{payroll.payrollName}}
                            </mat-option>
                            <mat-option *ngIf="filteredPayrollPeriods.length === 0 && periodSearchText" disabled>
                                <em>No periods found</em>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="PeriodGroup.get('payrollPeriodID')?.hasError('required')">
                            Period is required
                        </mat-error>
                    </mat-form-field>
                    <div class="button-row">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" matStepperNext
                            [disabled]="!PeriodGroup.valid">Next</button>
                    </div>
                </div>
            </form>
        </mat-step>

        <!-- Step 3: Select Date -->
        <mat-step [stepControl]="DateGroup" [editable]="true">
            <ng-template matStepLabel>Select Date</ng-template>
            <form [formGroup]="DateGroup" class="step-form">
                <div class="step-content">
                    <p class="step-description">Select the date range for leave</p>
                    <div class="date-fields">
                        <mat-form-field appearance="outline" class="date-field">
                            <mat-label>From</mat-label>
                            <input matInput [matDatepicker]="picker" [matDatepickerFilter]="dateFilter"
                                formControlName="datePick1" required placeholder="MM/DD/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                            <mat-error *ngIf="DateGroup.get('datePick1')?.hasError('required')">
                                From date is required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="date-field">
                            <mat-label>To</mat-label>
                            <input matInput [matDatepicker]="picker2" [matDatepickerFilter]="dateFilter"
                                formControlName="datePick2" required placeholder="MM/DD/YYYY">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="DateGroup.get('datePick2')?.hasError('required')">
                                To date is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="button-row">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" matStepperNext
                            [disabled]="!DateGroup.valid">Next</button>
                    </div>
                </div>
            </form>
        </mat-step>

        <!-- Step 4: Select Leave Type -->
        <mat-step [stepControl]="HRConceptGroup" [editable]="true">
            <ng-template matStepLabel>Leave Type</ng-template>
            <form [formGroup]="HRConceptGroup" class="step-form">
                <div class="step-content">
                    <p class="step-description">Select leave type and provide a reason</p>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Leave Type</mat-label>
                        <mat-select formControlName="hrconceptID" (openedChange)="onLeaveTypeDropdownOpenChange($event)"
                            required>
                            <mat-select-trigger>
                                {{ getSelectedLeaveType() || 'Select Leave Type' }}
                            </mat-select-trigger>
                            <mat-option class="search-option">
                                <input #leaveTypeSearchInput [(ngModel)]="leaveTypeSearchText"
                                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterLeaveTypes()"
                                    (click)="$event.stopPropagation()" placeholder="Search leave types..."
                                    class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let hr of filteredHRConcepts" [value]="hr.hrconceptID">
                                {{hr.conceptName}}
                            </mat-option>
                            <mat-option *ngIf="filteredHRConcepts.length === 0 && leaveTypeSearchText" disabled>
                                <em>No leave types found</em>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="HRConceptGroup.get('hrconceptID')?.hasError('required')">
                            Leave type is required
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Reason</mat-label>
                        <textarea matInput formControlName="comment" rows="4" required
                            placeholder="Enter the reason for this leave request"></textarea>
                        <mat-error *ngIf="HRConceptGroup.get('comment')?.hasError('required')">
                            Reason is required
                        </mat-error>
                    </mat-form-field>
                    <div class="button-row">
                        <button mat-button matStepperPrevious>Back</button>
                        <button mat-raised-button color="primary" matStepperNext
                            [disabled]="!HRConceptGroup.valid">Next</button>
                    </div>
                </div>
            </form>
        </mat-step>

        <!-- Step 5: Review and Submit -->
        <mat-step>
            <ng-template matStepLabel>Review</ng-template>
            <div class="step-content">
                <p class="step-description">Review the leave request details</p>
                <div class="review-section">
                    <div class="review-item">
                        <span class="review-label">Employee:</span>
                        <span class="review-value">{{getSelectedEmployeeName()}}</span>
                    </div>
                    <div class="review-item">
                        <span class="review-label">Period:</span>
                        <span class="review-value">{{getSelectedPeriodName()}}</span>
                    </div>
                    <div class="review-item">
                        <span class="review-label">Date From:</span>
                        <span class="review-value">{{DateGroup.get('datePick1')?.value | date:'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="review-item">
                        <span class="review-label">Date To:</span>
                        <span class="review-value">{{DateGroup.get('datePick2')?.value | date:'MM/dd/yyyy'}}</span>
                    </div>
                    <div class="review-item">
                        <span class="review-label">Leave Type:</span>
                        <span class="review-value">{{getSelectedLeaveType()}}</span>
                    </div>
                    <div class="review-item full-width">
                        <span class="review-label">Reason:</span>
                        <span class="review-value">{{HRConceptGroup.get('comment')?.value}}</span>
                    </div>
                </div>
                <div class="button-row">
                    <button mat-button matStepperPrevious>Back</button>
                    <button mat-raised-button color="primary" (click)="submitLeaveForm()" [disabled]="!isFormValid()">
                        <mat-icon>check</mat-icon>
                        Submit
                    </button>
                </div>
            </div>
        </mat-step>
    </mat-stepper>
</mat-dialog-content>